import React from 'react';

import createIcon from './createIcon';

const LocationAlt = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" {...props}>
    <title>Location</title>
    <path d="M256,64c-65.9,0-119.3,53.7-119.3,120c0,114.6,119.3,264,119.3,264s119.3-149.4,119.3-264C375.3,117.7,321.9,64,256,64z" />
  </svg>
);

export default createIcon(LocationAlt);
